import { configFetch as fetch } from '@laigu/utils';

// 功能权限
export const getFunctionPerms = () => {
  return fetch({
    url: '/enterprise/functions',
    method: 'get'
  });
};
